
export default async function getBlogs() {
    try {
        return fetch('/api/blogs.json?all=true')
            .then(res => res.json())
            .then(feed => feed.docs);
    } catch (error) {
        console.error('Failed to load blogs:', error);
        throw error;
    }
}

export async function getBlog(blogId) {
    try {
        const blogs = await getBlogs();
        const blog = blogs.find(blog => blog.id === blogId);

        blog.posts.docs.map(post => {
            post.url =  '/blogs/' + blog.slug + '/posts/' + post.slug;
        });

        return blog;
    } catch (error) {
        console.error('Failed to retrieve blog:', error);
        throw error;
    }
}
